import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import ClearIcon from "@mui/icons-material/Clear";
import pic from "./images/burger.png";
import { getAllServiceList } from "../../../config/allServiceJSON";
import { Loader } from "../../atoms/Loader";

const defaultServices = [
  {
    id: 1,
    name: "Google",
    image: "",
  },
  {
    id: 2,
    name: "MailChimp",
    image: "",
  },
  {
    id: 3,
    name: "Groove",
    image: "",
  },
  {
    id: 4,
    name: "Wordpress",
    image: "",
  },
  {
    id: 5,
    name: "Zoho OAuth",
    image: "",
  },
  {
    id: 6,
    name: "Zomato",
    image: "",
  },
  {
    id: 7,
    name: "Yelp",
    image: "",
  },
  {
    id: 8,
    name: "Yelp",
    image: "",
  },
  {
    id: 9,
    name: "Yelp",
    image: "",
  },
  {
    id: 10,
    name: "Yelp",
    image: "",
  },
  {
    id: 11,
    name: "Yelp",
    image: "",
  },
  {
    id: 12,
    name: "Yelp",
    image: "",
  },
  {
    id: 13,
    name: "Yelp",
    image: "",
  },
];
const customServices = [
  {
    id: 1,
    name: "Google",
    image: "",
  },
  {
    id: 2,
    name: "MailChimp",
    image: "",
  },
  {
    id: 3,
    name: "Groove",
    image: "",
  },
  {
    id: 4,
    name: "Wordpress",
    image: "",
  },
  {
    id: 5,
    name: "Zoho OAuth",
    image: "",
  },
  {
    id: 6,
    name: "Zomato",
    image: "",
  },
  {
    id: 7,
    name: "Yelp",
    image: "",
  },
];

const Services = ({
  dataCenter,
  orgId,
  apiKey,
  zApiKey,
  setService,
  setExpanded,
}) => {
  const [showSearchInput, setShowSearchInput] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [defaultButtonColor, setDefaultButtonColor] = useState("#1565c0");
  const [customButtonColor, setCustomButtonColor] = useState("gray");
  const [defaultService, setDefaultService] = useState(false);
  const [customService, setCustomService] = useState(false);
  const [selectedService, setSelectedService] = useState("default");

  const handleClear = () => {
    setSearchText(""); // Clear the text field
  };
  const handleSearchClick = () => {
    setShowSearchInput(!showSearchInput);
  };
  const handleClickDefaultButton = () => {
    setSelectedService("default");
    setDefaultButtonColor((prevColor) =>
      prevColor === "gray" ? "#1565c0" : "gray"
    );
    setCustomButtonColor("gray");
    setDefaultService(true);
    setCustomService(false);
  };
  const handleClickCustomButton = () => {
    setSelectedService("custom");
    setCustomButtonColor((prevColor) =>
      prevColor === "gray" ? "#1565c0" : "gray"
    );
    setDefaultButtonColor("gray");
    setDefaultService(false);
    setCustomService(true);
  };

  const allServices =
    selectedService === "default"
      ? defaultServices
      : [...defaultServices, ...customServices]; // Combine default and custom services if custom is selected

  const filteredScopes = allServices.filter((data) =>
    data?.name.toLowerCase().includes(searchText.toLowerCase())
  );

  if (!dataCenter) {
    return <Loader />;
  }

  return (
    <Box>
      <Box mb={1} sx={{ display: "flex" }}>
        <Box sx={{ display: "flex", width: "95%" }}>
          <Button
            sx={{
              color: defaultButtonColor,
              fontWeight: "bold",
              marginRight: "24px",
              textTransform: "none",
            }}
            onClick={handleClickDefaultButton}
          >
            Default Services
          </Button>
          <Button
            sx={{
              color: customButtonColor,
              fontWeight: "bold",
              textTransform: "none",
            }}
            onClick={handleClickCustomButton}
          >
            Custom Services
          </Button>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              width: showSearchInput ? "200px" : "0px",
              transition: "width 0.3s ease",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
            }}
          >
            <TextField
              size="small"
              placeholder="Search here..."
              variant="outlined"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              InputProps={{
                endAdornment: searchText && (
                  <InputAdornment position="end">
                    <IconButton onClick={handleClear} edge="end" size="small">
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                opacity: showSearchInput ? 1 : 0,
                transition: "opacity 0.3s ease 0.1s",
                width: "200px",
              }}
            />
          </Box>

          <IconButton
            sx={{
              backgroundColor: "#f5f7fa",
              borderRadius: 1,
              "&:hover": { backgroundColor: "#f0f0f0" },
              ml: 1,
            }}
            onClick={handleSearchClick}
          >
            <SearchIcon />
          </IconButton>
          <IconButton
            sx={{
              backgroundColor: "#f5f7fa",
              borderRadius: 1,
              "&:hover": { backgroundColor: "#f0f0f0" },
              ml: 1,
            }}
            //   onClick={handleSearchClick}
          >
            <SwapVertIcon />
          </IconButton>
        </Box>
      </Box>
      <Divider sx={{ marginBottom: "20px" }} />
      <Box
        sx={{
          maxHeight: "400px",
          overflowY: "auto",
          overflowX: "hidden",
          padding: "20px",
        }}
      >
        <Grid container xs={12}>
          {getAllServiceList(dataCenter).map((data) => (
            <Grid
              item
              spacing={2}
              padding={1}
              mb={1}
              xs={12}
              sm={6}
              md={4}
              lg={2.5}
              key={data.name}
              sx={{
                display: "flex",
                alignItems: "center",
                borderRadius: "5px",
                marginRight: "10px",
                border: "1px solid transparent", // Initial border
                transition: "border 0.3s ease", // Smooth transition
                "&:hover": {
                  border: "1px solid #1976d2", // Border color on hover
                },
                boxShadow:
                  "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)",
              }}
              onClick={() => {
                setExpanded((prev) => "panel2");
                setService((prev) => data);
              }}
            >
              <img src={pic} alt="service" width={"50px"} />
              <Typography
                sx={{
                  color: "#9e9e9e",
                  fontSize: "11px",
                  ml: 2,
                }}
              >
                SERVICE NAME
                <br />
                <Typography
                  sx={{
                    color: "black",
                    fontSize: "13px",
                  }}
                >
                  {" "}
                  {data?.name}
                </Typography>
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default Services;
